import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { SandboxPage } from 'src/app/model/page/sandbox-page';
import { CommonService } from 'src/app/service/common.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-issue-tickets-screen',
  templateUrl: './issue-tickets-screen.component.html',
  styleUrls: ['./issue-tickets-screen.component.scss']
})
export class IssueTicketsScreenComponent implements OnInit {
  sandboxPage: SandboxPage = {} as SandboxPage;
  constructor(private contentfulService: ContentfulService, private commonService: CommonService, private formBuilder: FormBuilder) {}
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  SearchCountryField = SearchCountryField;
  separateDialCode = false;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom, CountryISO.Spain, CountryISO.Germany, CountryISO.France, CountryISO.Russia];

  issueTicketsForm: FormGroup = new FormGroup({
    firstName: new FormControl(''),
    lastName: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl(''),
    zip: new FormControl(''),
    selectCountry: new FormControl(''),
    email: new FormControl(''),
    phone: new FormControl(''),
    cardDetails: new FormControl(''),
    cardNumber: new FormControl('')
  });

  ngOnInit(): void {
    const query = { 'fields.title': 'Sandbox' };
    this.contentfulService.getPageContentWithEntries(query).then((loginPageEntries) => {
      this.mapBanner(loginPageEntries);
    });

    this.issueTicketsForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      address1: ['', [Validators.required]],
      address2: ['', [Validators.required]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zip: ['', [Validators.required]],
      selectCountry: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, Validators.minLength(2), Validators.maxLength(30)]],
      phone: ['', [Validators.required]]
    });
  }

  private mapBanner(loginPageEntries: Entry<any>[]) {
    loginPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.sandboxPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  get countries() {
    return this.commonService.getCountries();
  }
}
